import { LocationDirection, Side, TranslateFunction } from "../models/Common"
import { ISolution } from "../models/Solution"
import {
  BaseComponent,
  IComponentInfo,
  IComponentLabels,
  IComponentShape,
} from "./Base"
import { PrintedBorder } from "./PrintedBorder"

export class ActiveArea extends BaseComponent {
  public constructor(
    id: number,
    solution: ISolution,
    t: TranslateFunction,
    printedBorder?: PrintedBorder,
    innerArea?: IComponentShape
  ) {
    const activeArea = solution.sensor.activeArea
    super(
      {
        id,
        color: "#cc0000",
        description: t("d_active"),
      } as IComponentInfo,
      {
        width: activeArea.width,
        height: activeArea.height,
        centralOffsetX: solution.sensor.offset.x,
        centralOffsetY: solution.sensor.offset.y,
      } as IComponentShape,
      {
        dimensions: {
          sides: [Side.Bottom, Side.Right],
          diff: true,
        },
        description: false,
        id: {
          locationDirection: LocationDirection.Inward,
          fromSide: Side.Right,
          referenceShape: innerArea,
          padding: 20,
        },
      } as IComponentLabels
    )
  }
}
